import BasicRouterView from "../../../components/BasicRouterView.vue";

const ajusteEstoque = {
  path: "ajus",
  redirect: { name: "salvos" },
  meta: {
    label: "Ajuste Estoque",
    icon: "web_stories",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "ajuste-estoque/ajuste-estoque-novo",
      name: "ajuste-estoque-novo",
      meta: {
        label: "NOVO",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "../ajusteEstoque/views/Novo.vue"),
    },
  ],
};

export default ajusteEstoque;
